export default __webpack_public_path__ + "static/media/quiz-logo.a7491fcf.png";